// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"494":"285681c7","496":"25abac0d"}[chunkId] + ".chunk.js";
};